import { castArray } from '../views/utils'
import { joinReferences } from './consts'
import storeModules from './modules'
const { PARENT, CHILD, PIVOT } = joinReferences

const getSuspectKeys = (() => {
  const discardConventionKeys = key => !['At', 'On', 'Date', 'Id']
    .some(suffix => key.endsWith(suffix))

  return record => Object
    .keys(record)
    .filter(discardConventionKeys)
    .filter(key => record[key] &&
      (Array.isArray(record[key]) ||
        (typeof record[key] === 'object' &&
          record[key].id)))
    .sort((a, b) => b.length - a.length)
})()

const implyStoreModule = (() => {
  const sortedStoreModules = storeModules
    .filter(storeModule => storeModule.serviceName)
    .sort((a, b) => a.serviceName.length - b.serviceName.length)

  const storeServiceNamesLowercase = sortedStoreModules
    .map(storeModule => storeModule.serviceName.toLowerCase())

  return (keyLowerCase) => {
    const serviceIndex = storeServiceNamesLowercase.indexOf(keyLowerCase)
    return sortedStoreModules[serviceIndex !== -1
      ? serviceIndex
      : storeServiceNamesLowercase
        .findIndex(lowercaseName => keyLowerCase.includes(lowercaseName))]
  }
})()

const implyReferenceType = (pivotOptions, record, key) => {
  if (pivotOptions && Object.keys(pivotOptions).length) return PIVOT
  if (typeof record[`${key}Id`] !== 'undefined') return PARENT
  return CHILD
}

const formReferenceOptions = (referenceType, joinKey, parentTableName) => {
  if (referenceType === PIVOT) return
  return {
    parentKey: referenceType === CHILD ? 'id' : `${joinKey}Id`,
    childKey: referenceType === CHILD ? `${parentTableName}Id` : 'id',
  }
}

export default function implyJoins(recordsOrRecord, parentTableName, foundJoins = {}) {
  if (!recordsOrRecord) return {}

  const parentTableNameLowerCase = parentTableName.toLowerCase()
  const records = castArray(recordsOrRecord)
  if (!records.length) return {}

  // TODO: optimize forEach - skip unnecessary runs
  records.forEach((record) => {
    const suspectedKeys = getSuspectKeys(record)
    const lowercaseSuspectedKeys = suspectedKeys.map(key => key.toLowerCase())
    const suspectedChildren = suspectedKeys.map(key => [key, record[key]])
    // const BLANK = {}
    // const SKIP = null

    suspectedKeys
      .forEach((key, _keyIndex) => {
        if (foundJoins[key]) return

        const keyLowerCase = key.toLowerCase()
        const hasMany = Array.isArray(record[key])
        const { storeKey, tableName, serviceName } = implyStoreModule(keyLowerCase)

        const pivotOptions = hasMany && (() => {
          // TODO: finish this method for a better pivot table detection which is name independent
          // NOTE: Experimental detection method
          // NOTE: strictly assumes that relation object comes right before it
          // const expectedPivotIndex = keyIndex - 1
          // if (expectedPivotIndex === -1) return BLANK

          // const expectedPivotKey = suspectedKeys[expectedPivotIndex]
          // const expectedPivots = record[expectedPivotKey]
          // if (!Array.isArray(expectedPivots)) return BLANK
          // if (expectedPivots.length !== record[key].length) return BLANK
          // TODO: check by id match
          // TODO: allow to elavate referenceType
          // if (!expectedPivots.length) {
          //   return isRecordLast ? BLANK : SKIP
          // }

          // return {
          //   via: expectedPivotKey,
          //   viaChildKey,
          // }

          // const viaChildKey = `${tableName}Id`
          // const pivotKeys = Object.keys(expectedPivots[0])

          // if (!pivotKeys.includes(viaChildKey) || !pivotKeys.includes(`${key}Id`)) return BLANK

          // NOTE: older relationship detection method based on strict naming
          // TODO: smarter via field detection instead of blind faith in conventional naming
          const viaServiceNameIndex = lowercaseSuspectedKeys
            .findIndex(joinKey => joinKey === `${keyLowerCase}${parentTableNameLowerCase}` ||
              joinKey === `${parentTableNameLowerCase}${keyLowerCase}`)

          if (viaServiceNameIndex === -1) return {}

          return {
            via: suspectedKeys[viaServiceNameIndex],
            viaChildKey: `${tableName}Id`,
          }
        })()

        const referenceType = implyReferenceType(pivotOptions, record, key)
        const referenceOptions = formReferenceOptions(referenceType, key, parentTableName)

        foundJoins[key] = {
          hasMany,
          referenceType,
          tableName,
          storeKey,
          serviceName,
          ...pivotOptions,
          ...referenceOptions,
          children: {},
        }
      })

    suspectedChildren
      .filter(([_, child]) => child && (child.length || !Array.isArray(child)))
      .forEach(([key, child]) => {
        implyJoins(child, foundJoins[key].tableName, foundJoins[key].children)
      })
  })

  return foundJoins
}
